import { Beef, Pizza, Salad, Sandwich, Globe, UtensilsCrossed } from "lucide-react";

export const CUISINES = ["Burger", "Tacos", "Pizza", "Vegan", "Cuisine du monde"];

const MAP = {
  burger: { Icon: Beef, bg: "#FFE7C6", fg: "#C2611A" },
  tacos: { Icon: Sandwich, bg: "#FFE0DE", fg: "#C23B36" },
  pizza: { Icon: Pizza, bg: "#FFF1D6", fg: "#B8860B" },
  vegan: { Icon: Salad, bg: "#DCF3EF", fg: "#1B9086" },
  "cuisine du monde": { Icon: Globe, bg: "#E9E3F5", fg: "#5B4B8A" },
};

export const cuisineStyle = (c) => MAP[(c || "").toLowerCase()] || { Icon: UtensilsCrossed, bg: "#EAE3D3", fg: "#0E3F5B" };
